import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import Header from '../Header/Header';

const AutomatedOnboardingHeader = props => {
  const { commonProps, budgetVersion, numOfYears } = props;
  const {
    services: { CommonService },
  } = commonProps;

  const { t } = useTranslation();
  const tc = (e, data) => (data ? t(`autoonboard_common:${e}`, data) : t(`autoonboard_common:${e}`));

  const isAutoOnboardingWithoutSampleBudgetEnabled = CommonService.isAutoOnboardingWithoutSampleBudgetEnabled;

  return (
    <div className="automatedOnboardingHeaderContainer">
      <Header headerIcon="icon-centage-primary-logo" />
      <div className="titleContainer">
        <div className="title">{tc('AUTOMATED_ONBOARDING_TITLE')}</div>
        {!isAutoOnboardingWithoutSampleBudgetEnabled && (
          <div className="subtitle">
            <Trans t={tc} i18nKey="AUTOMATED_ONBOARDING_SUBTITLE"></Trans>
          </div>
        )}
        {isAutoOnboardingWithoutSampleBudgetEnabled && (
          <div className="subtitle">
            <Trans t={tc} i18nKey="AUTOMATED_ONBOARDING_SUBTITLE_NO_SAMPLE_BUDGET"></Trans>
          </div>
        )}
      </div>
    </div>
  );
};

export default AutomatedOnboardingHeader;